export const THEME_ADJECTIVES = [
  // Original adjectives
  "Amazing",
  "Quirky",
  "Creative",
  "Brilliant",
  "Unique",
  "Exciting",
  "Magical",
  "Fantastic",
  "Innovative",
  "Inspiring",
  "Delightful",
  "Enchanting",
  "Intriguing",
  "Captivating",
  
  // Additional positive adjectives
  "Vibrant",
  "Dazzling",
  "Extraordinary",
  "Marvelous",
  "Stunning",
  "Remarkable",
  "Wonderful",
  "Spectacular",
  "Impressive",
  "Breathtaking",
  "Exceptional",
  "Phenomenal",
  "Mesmerizing",
  "Astounding",
  "Splendid",
  "Radiant",
  "Glorious",
  "Exquisite",
  "Magnificent",
  "Incredible",
  "Astonishing",
  "Mind-blowing",
  "Sensational",
  "Fascinating",
  "Charismatic",
  "Whimsical",
  "Dynamic",
  "Visionary",
  "Elegant",
  "Sublime",
  "Exhilarating",
  "Electrifying",
  "Clever",
  "Imaginative",
  "Ingenious",
  "Stellar",
  "Striking",
  "Bold",
  "Luminous",
  "Harmonious",
  "Refreshing",
  "Cutting-edge",
  "Groundbreaking",
  "Trendsetting",
  "Revolutionary",
  "Trailblazing",
  "Futuristic",
  "Awe-inspiring",
  "Charming",
  "Thrilling",
  "Alluring"
]; 